module.exports = __webpack_public_path__ + "img/banner-1.b0ac0b17.png";